/*
 * @Author: your name
 * @Date: 2021-09-22 17:25:34
 * @LastEditTime: 2021-11-09 14:55:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /we-media/src/main.js
 */
import Vue from 'vue';

import { initAdapter, getAdapter, ZYToast, env } from '@zyf2e/adapt';
import * as globalComponents from '@/components/index';
// import * as filters from '@/filters';

import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/styles/index.less';
import {
  Image,
  Dialog,
  Skeleton,
  Toast,
  List,
  PullRefresh,
  Empty,
  Button,
  Overlay,
  Lazyload,
} from '@zyf2e/capui-mobile';

Vue.use(Image)
  .use(Dialog)
  .use(List)
  .use(Skeleton)
  .use(Empty)
  .use(Button)
  .use(PullRefresh)
  .use(Overlay)
  .use(Lazyload)
  .use(Toast);

// Object.keys(filters).forEach((key) => {
//   Vue.filter(key, filters[key]);
// });
Object.keys(globalComponents).forEach(key => {
  Vue.component(key, globalComponents[key].default);
});

Vue.directive('track-view', Telescope.vTrackView);
Vue.directive('track-event', Telescope.vTrackEvent);

window.Vue = Vue;

try {
  const doctorPageList = ['doctor-article', 'audit-view'];
  const isDoctor = doctorPageList.some(el => location.href.indexOf(el) > 0); // 是否为医生端页面
  const trackKey = isDoctor
    ? '296e403cbe496c543b72415570c9c03d'
    : 'acd2bf9921d1c93e260c4626e1a7d88b';
  Telescope.setConfig({
    autoTrackClick: false,
    trackKey,
    version: '1.0.0',
  });
} catch (error) {
  // do
}

Vue.config.productionTip = false;

env.inAPP && Sailer.hideNavBar();

async function main() {
  if (env.inAPP && env.inIframe) {
    setTimeout(() => {
      Sailer.fire('ready');
    }, 100);
  }
  await initAdapter({
    baseURL: process.env.ZY_SERVICE,
    jumpWechatMPLogin: true,
  });
  Vue.prototype.telescope = Telescope;
  Vue.prototype.adapter = await getAdapter();
  Vue.prototype.ZYToast = ZYToast;
  Vue.prototype.env = env;
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

main();
